/**
 * Reorders an array of items to place selected items at the top
 * @param items - Array of items to reorder
 * @param selectedIds - Array of IDs that should be moved to the top
 * @returns Reordered array with selected items first, followed by unselected items
 */

export function reorderItems<T extends { id: string }>(items: T[], selectedIds: string[]): T[] {
  if (!items?.length || !selectedIds?.length) {
    return items;
  }

  const selected: T[] = [];
  const unselected: T[] = [];

  for (const item of items) {
    if (selectedIds.includes(item.id)) {
      selected.push(item);
    } else {
      unselected.push(item);
    }
  }

  return [...selected, ...unselected];
}
